import { useLottie } from "lottie-react";
import animationData from "constants/lottiesFiles/datagridloading.json";

const options = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

function DataGridLoadingAnimation({ height, width }) {
  const { View } = useLottie(options, { height: height, width: width });

  return View;
}

export default DataGridLoadingAnimation;
